import { Subscription, switchMap } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpMemberService } from '../../../service/http-member.service';
import { MemberDto } from '../../../service/dto';
import { Router } from '@angular/router';
import { HierarchyService } from '../../../service/hierarchy.service';

@Component({
	selector: 'app-member-list',
	standalone: false,
	templateUrl: './member-list.component.html',
	styleUrl: './member-list.component.scss'
})
export class MemberListComponent implements OnInit, OnDestroy{
	data: MemberDto[] = [];
	subscription = new Subscription();
	constructor(private httpService: HttpMemberService, private hierarchyService: HierarchyService, private router: Router) {

	}
	ngOnInit(): void {
		this.subscription.add(this.hierarchyService.hierarchy$
			.pipe(
				switchMap(item => this.httpService.getAll())
			)
			.subscribe(result => this.data = result));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doView(input: MemberDto) {
		this.router.navigate(['/member', input.id, 'view']);
	}
}
